(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 4672:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform",
      function () {
        return __webpack_require__(6603);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var GradientContainer = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _gradientDirection = param.gradientDirection, gradientDirection = _gradientDirection === void 0 ? "bg-gradient-to-tl" : _gradientDirection, overrideClassName = param.overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(gradientDirection, " ").concat(light ? "from-[#86EFAC] to-[#67E8F9]" : "from-[#22C55E] to-[#06B6D4]", "\n    ").concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GradientContainer);


/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 2217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

var Input = function(_param) {
    var type = _param.type, label = _param.label, placeholder = _param.placeholder, labelClassName = _param.labelClassName, inputClassName = _param.inputClassName, inputProps = _objectWithoutProperties(_param, [
        "type",
        "label",
        "placeholder",
        "labelClassName",
        "inputClassName"
    ]);
    var labelDefaultClassName = "text-text-color-high-em";
    var inputDefaultClassName = "w-full rounded-lg border-[#D0D5DD] mt-1 text-text-color-high-em";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: labelClassName ? labelClassName : labelDefaultClassName,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({
                type: type ? type : "text",
                placeholder: placeholder,
                className: "".concat(inputDefaultClassName, " ").concat(inputClassName)
            }, inputProps))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 6603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ platform; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
;// CONCATENATED MODULE: ./components/platform/hero.tsx



var Hero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-background-primary-dark-dark py-10 xl:py-20 flex flex-col items-center",
            style: {
                backgroundImage: "url(/images/platform/hero-bg-v2.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-2 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "mobile-h4 sm:h5 md:h4 xl:h3 text-white",
                            children: [
                                "One ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[#4ADE80]",
                                    children: "powerful"
                                }),
                                " platform"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            className: "mobile-h4 sm:h5 md:h4 xl:h3 text-white",
                            children: [
                                "Three ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[#4ADE80]",
                                    children: "distinct"
                                }),
                                " functions"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                    overrideClassName: "w-[150px] h-[8px] my-10 xl:mt-6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:flex items-center lg:space-x-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-4 text-center lg:text-right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "subheading-xl-2 sm:subheading-xxl-2 md:subheading-xxxl-2 xl:subheading-xxxxl-2 text-white",
                                    children: "Technology"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "subheading-xl-3 sm:subheading-xxl-3 md:subheading-xxxl-3 xl:subheading-xxxxl-3 text-[#4ADE80]",
                                    children: "Procurement"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "subheading-xl-4 sm:subheading-xxl-4 md:subheading-xxxl-4 xl:subheading-xxxxl-4 italic text-[#22D3EE]",
                                    children: "Support"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-[312px] h-[268px] sm:w-[439px] sm:h-[376px] xl:h-[336px] xl-2:w-[579px] xl-2:h-[349px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/platform/hero.png",
                                alt: "hero",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var hero = (Hero);

;// CONCATENATED MODULE: ./components/platform/technology.tsx

/* eslint-disable @next/next/no-img-element */ 
var TechnologyItem = function(param) {
    var description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                gradientDirection: "bg-gradient-to-t",
                overrideClassName: "h-[44px] w-[4px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-text-color-mid-em text-body-xl-medium",
                children: description
            })
        ]
    });
};
var TechnologyItems = [
    {
        key: "01",
        description: "Centralize your operations"
    },
    {
        key: "02",
        description: "Track your services"
    },
    {
        key: "03",
        description: "Drive workforce production"
    },
    {
        key: "04",
        description: "Capture data analytics"
    },
    {
        key: "05",
        description: "Enhance your process"
    }, 
];
var Technology = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-10 lg:p-20 xl:px-[120px] xl-2:px-[160px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-2 mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "text-secondary text-body-2xl md:subheading-xl lg:subheading-xxl-2",
                        children: "Technology"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-full h-[4px] rounded"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row lg:space-x-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center space-y-6 lg:basis-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "rounded w-full",
                                src: "/images/platform/services.png",
                                alt: "technology"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 sm:px-20 md:px-36 lg:px-0 xl-2:px-8 2xl:px-20 3xl:px-36",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-text-color-high-em h6 text-center xl:h5",
                                    children: "Our tech stack was designed for the waste and recycling industry"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 space-y-10 lg:mt-0 lg:basis-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "text-base-dark text-center h6 sm:h5 lg:text-start lg:h4 xl:h3 4xl:pr-20",
                                children: "Discover the benefits of advanced technology."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-4",
                                children: TechnologyItems.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnologyItem, {
                                        description: item.description
                                    }, item.key);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var technology = (Technology);

;// CONCATENATED MODULE: ./components/platform/procurement.tsx

/* eslint-disable @next/next/no-img-element */ 
var ProcurementItem = function(param) {
    var description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                light: true,
                overrideClassName: "h-[44px] w-[4px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-white text-body-lg sm:text-body-xl md:text-body-xl-medium",
                children: description
            })
        ]
    });
};
var ProcurementItems = [
    {
        key: "01",
        description: "Realize direct savings"
    },
    {
        key: "02",
        description: "Optimize deal structures"
    },
    {
        key: "03",
        description: "Gain best options"
    },
    {
        key: "04",
        description: "Strengthen market position"
    },
    {
        key: "05",
        description: "Automate RFP Processing"
    }, 
];
var Procurement = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-background-primary-dark-dark py-20 px-10 lg:px-20 xl:px-[120px] xl-2:px-[160px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "text-[#BBF7D0] text-start h5 lg:text-end md:h4 lg:h3",
                children: "Procurement"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                overrideClassName: "w-full h-1 mt-1 rounded"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10 space-y-8 flex flex-col lg:space-y-0 lg:flex-row lg:items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-8 lg:basis-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-white mobile-h4 sm:h5 sm:pr-5 md:h4 lg:h3 md:pr-9 xl:pr-0",
                                    children: "Experience the SimpleWaste Network Advantage."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-4",
                                children: ProcurementItems.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcurementItem, {
                                        description: item.description
                                    }, item.key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full 3xl:pr-32 4xl:pr-64",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hidden xl:block text-white text-body-lg text-center",
                                    children: "At SimpleWaste, we procure savings in three distinct categories: contract pricing, facility operations, and RFP processing."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:basis-1/2 space-y-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "rounded",
                                src: "/images/platform/procurement.png",
                                alt: "Procurement"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white text-center h6 xl:h5",
                                children: "Discover your savings potential and plan options with a LIVE Demo."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "xl:hidden text-white text-body-lg text-center",
                                children: "At SimpleWaste we procure savings in three distinct categories: contract pricing, facility operations, and RFP processing."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var procurement = (Procurement);

// EXTERNAL MODULE: ./components/gradient/gradient-text.tsx
var gradient_text = __webpack_require__(3725);
;// CONCATENATED MODULE: ./components/platform/support.tsx

/* eslint-disable @next/next/no-img-element */ 

var SupportFeatureItem = function(param) {
    var icon = param.icon, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-background-primary-dark-dark w-[105px] h-[100px] rounded-lg flex flex-col items-center justify-center space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/assets/svgs/platform/".concat(icon, ".svg"),
                alt: "".concat(label)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "text-white label-md",
                children: label
            })
        ]
    });
};
var SupportItem = function(param) {
    var description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center space-x-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                overrideClassName: "h-[44px] w-[4px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-text-color-mid-em text-body-lg sm:text-body-xl-medium",
                children: description
            })
        ]
    });
};
var SupportFeatureItems = [
    {
        key: "01",
        icon: "phone-call",
        label: "Phone"
    },
    {
        key: "02",
        icon: "chat",
        label: "Chat"
    },
    {
        key: "03",
        icon: "share",
        label: "Screenshare"
    }, 
];
var SupportItems = [
    {
        key: "01",
        description: "Access live support"
    },
    {
        key: "02",
        description: "Prioritize your communications"
    },
    {
        key: "03",
        description: "Share rapid solutions"
    },
    {
        key: "04",
        description: "Elevate team experience"
    },
    {
        key: "05",
        description: "Boost software engagement"
    }, 
];
var Support = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-20 px-10 lg:px-20 xl:px-[120px] xl-2:px-[160px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_text/* default */.Z, {
                        overrideClassName: "italic subheading-xl-3 sm:h3",
                        children: "Support"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-full h-[4px] rounded"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row lg:space-x-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 space-y-6 lg:basis-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "rounded",
                                src: "/images/platform/support.png",
                                alt: "Support"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "text-text-color-high-em text-center h6 sm:h5",
                                children: "LIVE help anytime you need it."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center space-x-2",
                                children: SupportFeatureItems.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportFeatureItem, {
                                        icon: item.icon,
                                        label: item.label
                                    }, item.key);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-text-color-high-em text-center text-body-md sm:text-body-lg",
                                children: "24/7 access to customer support through your preferred channel."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-10 mt-12 lg:basis-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                    className: "text-base-dark h6 sm:h4 xl:h3",
                                    children: [
                                        "Discover the benefits of dedicated",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-secondary-light",
                                            children: "\xa0support."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-4",
                                children: SupportItems.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportItem, {
                                        description: item.description
                                    }, item.key);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var support = (Support);

// EXTERNAL MODULE: ./node_modules/@mdi/react/Icon.js
var Icon = __webpack_require__(8849);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);
// EXTERNAL MODULE: ./node_modules/@mdi/js/mdi.js
var mdi = __webpack_require__(5317);
;// CONCATENATED MODULE: ./components/platform/setup.tsx

/* eslint-disable @next/next/no-img-element */ 


var Setup = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-background-primary-dark-dark xxxs:pb-10 md:pb-24 overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center pt-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-white text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "md:text-body-xl xxxs:text-body-md",
                                children: "Work your way."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mobile-h3 md:h2",
                                children: "Easy to set up and use."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                        overrideClassName: "w-36 h-2 mt-3"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 md:mt-24 px-5 flex flex-col-reverse space-y-5 md:flex-row md:items-center md:px-0 md:space-y-0 2xl:px-40 4xl:px-48",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:basis-1/2 flex justify-center md:relative md:-left-12 lg:-left-16 xl:-left-24 3xl:!static",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "images/platform/integrations.png",
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-3 pb-6 md:pb-0 md:basis-1/2 md:px-8 xl:px-24 md:space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                        overrideClassName: "p-3 mb-2 w-12 rounded-full shadow-outer-secondary",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                            size: 1,
                                            path: mdi/* mdiApplicationSettings */.aZE,
                                            className: "text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-white mobile-h4 md:h5 lg:h4",
                                        children: "Works with what you already have."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "xxxs:text-body-lg lg:text-body-xl text-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "SimpleWaste integrates with QuickBooks, Office 365, Dropbox, Slack, Monday, Asana, and more seamlessly."
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 md:mt-24 px-5 flex flex-col-reverse space-y-5 md:flex-row-reverse md:items-center md:px-0 md:space-y-0 2xl:px-40 4xl:px-48",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:basis-1/2 flex justify-center md:relative md:-right-12 lg:-right-16 xl:-right-24 3xl:!static",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "images/platform/location.png",
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-3 pb-6 md:pb-0 md:basis-1/2 md:px-8 xl:px-24 md:space-y-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                        overrideClassName: "p-3 mb-2 w-12 rounded-full shadow-outer-secondary",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                            size: 1,
                                            path: mdi/* mdiApplicationSettings */.aZE,
                                            className: "text-white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-white mobile-h4 md:h5 lg:h4",
                                        children: "Keeps you in control on the go."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "xxxs:text-body-lg lg:text-body-xl text-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Anywhere, anytime. 24/7 access, even on the go."
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var setup = (Setup);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./contexts/theme-context.tsx
var theme_context = __webpack_require__(9746);
// EXTERNAL MODULE: ./constants/default.ts
var constants_default = __webpack_require__(5989);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(3253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./lib/helpers.ts
var helpers = __webpack_require__(7087);
;// CONCATENATED MODULE: ./components/modal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var defaultModalStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "0.375rem",
        minWidth: "25vw",
        maxWidth: "60rem",
        minHeight: "25vh",
        overlfow: "scroll"
    }
};
lib_default().setAppElement(constants_default/* ELEMENT_ROOT_ID */.yg);
var Modal = function(_param) {
    var children = _param.children, overrideStyles = _param.overrideStyles, modalProps = _objectWithoutProperties(_param, [
        "children",
        "overrideStyles"
    ]);
    var theme = (0,react.useContext)(theme_context/* ThemeContext */.Ni).theme;
    var isDark = theme === "dark";
    var customModalStyles = {
        overlay: {
            backgroundColor: isDark ? "rgba(0, 0, 0, 0.50)" : "rgba(0, 0, 0, 0.25)",
            zIndex: constants_default/* Z_INDECES.MODAL_OVERLAY */.F4.MODAL_OVERLAY
        },
        content: _objectSpread({}, defaultModalStyles.content, {
            zindex: constants_default/* Z_INDECES.MODAL */.F4.MODAL,
            borderColor: isDark ? helpers/* extractedTailwindTheme.colors.gray.800 */.Zh.colors.gray[800] : helpers/* extractedTailwindTheme.colors.gray.300 */.Zh.colors.gray[300],
            backgroundColor: isDark ? helpers/* extractedTailwindTheme.colors.background.main.dark */.Zh.colors.background.main.dark : helpers/* extractedTailwindTheme.colors.base.DEFAULT */.Zh.colors.base.DEFAULT
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), _objectSpread({
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        style: (0,lodash.merge)(customModalStyles, overrideStyles)
    }, modalProps, {
        children: children
    }));
};
/* harmony default export */ var modal = (Modal);

// EXTERNAL MODULE: ./components/schedule-demo.tsx + 1 modules
var schedule_demo = __webpack_require__(9449);
// EXTERNAL MODULE: ./components/button.tsx
var components_button = __webpack_require__(6625);
// EXTERNAL MODULE: ./components/input.tsx
var input = __webpack_require__(2217);
;// CONCATENATED MODULE: ./components/partners-landing-sections/prompt/prompt-modal.tsx







var PartnersLandingSectionPromptModal = function(param) {
    var onClose = param.onClose, onProceed = param.onProceed;
    var ref = (0,react.useState)(""), typedOption = ref[0], setTypedOption = ref[1];
    var ref1 = (0,react.useState)(""), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var isChecked = function(option) {
        return selectedOption === option;
    };
    var positions = [
        "Club Manager",
        "General Manager",
        "Executive Chef",
        "Superintendent",
        "CFO", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            zIndex: constants_default/* Z_INDECES.MODAL */.F4.MODAL
        },
        className: "rounded-xl flex flex-col space-y-5 p-6 bg-light w-[95vw] xs:w-[80vw] sm:w-[480px] text-text-color-high-em",
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/assets/svgs/global/logo-mark.svg",
                    width: 143,
                    height: 24,
                    alt: "logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "subheading",
                children: "Select Option:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    positions.map(function(position) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "flex space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "radio",
                                    className: "text-secondary focus:ring-secondary",
                                    style: {
                                        backgroundImage: "none"
                                    },
                                    checked: isChecked(position),
                                    onChange: function() {
                                        return setSelectedOption(position);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-body-md",
                                    children: position
                                })
                            ]
                        }, position);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "mt-1 text-secondary focus:ring-secondary",
                                type: "radio",
                                style: {
                                    backgroundImage: "none"
                                },
                                checked: isChecked("others"),
                                onChange: function() {
                                    return setSelectedOption("others");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                value: isChecked("others") ? typedOption : "",
                                onChange: function(e) {
                                    return setTypedOption(e.target.value);
                                },
                                onClick: function() {
                                    return setSelectedOption("others");
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-10 flex space-x-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        buttonType: "base",
                        size: "sm",
                        full: true,
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                        size: "sm",
                        full: true,
                        onClick: onProceed,
                        disabled: (0,lodash.isEmpty)(selectedOption) || selectedOption === "others" && (0,lodash.isEmpty)(typedOption),
                        children: "Proceed"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var prompt_modal = (PartnersLandingSectionPromptModal);

;// CONCATENATED MODULE: ./components/partners-landing-sections/prompt/index.tsx








var PartnersLandingSectionPrompt = function(param) {
    var offerLabel = param.offerLabel;
    var ref = (0,theme_context/* useThemeContext */.TC)(), isMobile = ref.isMobile, isTablet = ref.isTablet, isPartnerPromptOpen = ref.isPartnerPromptOpen, setIsPartnerPromptOpen = ref.setIsPartnerPromptOpen;
    var isDesktop = !(isMobile || isTablet);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-8 py-6 sm:p-10 lg:px-20 lg:py-10 relative",
        style: {
            zIndex: constants_default/* Z_INDECES.FLOATING_COMPONENT */.F4.FLOATING_COMPONENT
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
            overrideClassName: "rounded-2xl px-8 py-10 sm:p-12 xl:p-16",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-12 gap-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-12 md:col-span-8 flex flex-col items-start space-y-4",
                        children: [
                            offerLabel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-primary-dark rounded-full bg-secondary-low-em label-sm-bold sm-2:label-lg sm:subheading text-center sm:text-start py-2 px-3 sm-2:px-6 w-full sm:w-auto",
                                children: offerLabel
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h5 xs:h4 sm:h3 md:h4 lg:h3 xl:h2 text-light",
                                children: "Start Saving with SimpleWaste."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(schedule_demo/* default */.Z, {
                        skipIntro: true,
                        children: function(setIsScheduleModalOpen) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative col-span-12 md:col-span-4 flex items-start md:items-center md:justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonType: "base",
                                        className: "hidden md:block",
                                        size: "3xl",
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setIsPartnerPromptOpen(true);
                                        },
                                        children: "Schedule Demo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonType: "base",
                                        className: "hidden sm:block md:hidden",
                                        full: true,
                                        size: "3xl",
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setIsPartnerPromptOpen(true);
                                        },
                                        children: "Schedule Demo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                        buttonType: "base",
                                        className: "sm:hidden",
                                        full: true,
                                        size: "sm",
                                        onClick: function(e) {
                                            e.stopPropagation();
                                            setIsPartnerPromptOpen(true);
                                        },
                                        children: "Schedule Demo"
                                    }),
                                    isPartnerPromptOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block absolute top-32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prompt_modal, {
                                            onClose: function() {
                                                return setIsPartnerPromptOpen(false);
                                            },
                                            onProceed: function() {
                                                setIsScheduleModalOpen(true);
                                                setIsPartnerPromptOpen(false);
                                            }
                                        })
                                    }),
                                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal, {
                                        isOpen: isPartnerPromptOpen,
                                        onRequestClose: function() {
                                            return setIsPartnerPromptOpen(false);
                                        },
                                        overrideStyles: {
                                            content: {
                                                minHeight: 0,
                                                border: 0,
                                                padding: 0,
                                                borderRadius: 12
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prompt_modal, {
                                            onClose: function() {
                                                return setIsPartnerPromptOpen(false);
                                            },
                                            onProceed: function() {
                                                setIsScheduleModalOpen(true);
                                                setIsPartnerPromptOpen(false);
                                            }
                                        })
                                    })
                                ]
                            });
                        }
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var partners_landing_sections_prompt = (PartnersLandingSectionPrompt);

;// CONCATENATED MODULE: ./components/platform/table.tsx

/* eslint-disable @next/next/no-img-element */ 



var SimpleWasteAccountFeatures = [
    "Immediate Savings",
    "Flex Terms Options",
    "Custom Plans",
    "Extra Service Discounts",
    "Value-Added Services",
    "RFP Optimization",
    "Easy Sign-Up",
    "Unlimited Account Users",
    "Dashboard & Mobile App",
    "KPI & Data Tracking",
    "API Integrations",
    "Live Support"
];
var TraditionalBrokerFeatures = [
    "Immediate Savings - Limited",
    "Flex Terms Options - Limited"
];
var TypicalHaulerAccountFeatures = [
    "Immediate Savings - Limited",
    "Flex Terms Options - Limited",
    "Custom Plans - Limited",
    "Extra Service Discounts - Limited",
    "Value-Added Services - Limited"
];
var TableData = [
    {
        feature: "Immediate Savings",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#F9FAFB"
    },
    {
        feature: "Flex Terms Options",
        SWA: true,
        TB: false,
        THA: "Limited",
        columnBg: "#FFFFFF"
    },
    {
        feature: "Custom Plans",
        SWA: true,
        TB: "Limited",
        THA: "Limited",
        columnBg: "#F9FAFB"
    },
    {
        feature: "Extra Service Discounts",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#FFFFFF"
    },
    {
        feature: "Value-Added Services",
        SWA: true,
        TB: "Limited",
        THA: "Limited",
        columnBg: "#F9FAFB"
    },
    {
        feature: "RFP Optimization",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#FFFFFF"
    },
    {
        feature: "Easy Sign-Up",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#F9FAFB"
    },
    {
        feature: "Unlimited Account Users",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#FFFFFF"
    },
    {
        feature: "Dashboard & Mobile App",
        SWA: true,
        TB: false,
        THA: "Limited",
        columnBg: "#F9FAFB"
    },
    {
        feature: "KPI & Data Tracking",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#FFFFFF"
    },
    {
        feature: "API Integrations",
        SWA: true,
        TB: false,
        THA: false,
        columnBg: "#F9FAFB"
    },
    {
        feature: "Live Support",
        SWA: true,
        TB: false,
        THA: "Limited",
        columnBg: "#FFFFFF",
        isLast: true
    }, 
];
var checkSrc = "assets/svgs/platform/table-check.svg";
var checkGreySrc = "assets/svgs/platform/table-check-grey.svg";
var crossSrc = "assets/svgs/platform/table-cross.svg";
var Table = function() {
    var isMobile = (0,react.useContext)(theme_context/* ThemeContext */.Ni).isMobile;
    var GradientList = function(param) {
        var features = param.features;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "border border-secondary rounded-t-2xl rounded-b-2xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                    overrideClassName: "p-6 rounded-t-2xl text-center text-white text-body-xl-medium",
                    children: "SimpleWaste Account"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-text-color-high-em text-body-lg",
                            children: "All Features:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: features.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-start space-x-2 my-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: checkSrc,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[#667085] text-body-lg",
                                            children: item
                                        })
                                    ]
                                }, item);
                            })
                        })
                    ]
                })
            ]
        });
    };
    var GreyList = function(param) {
        var title = param.title, features = param.features;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "border border-[#E5E7EB] rounded-t-2xl rounded-b-2xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-6 rounded-t-2xl text-center border-b border-[#E5E7EB] text-text-color-high-em text-body-xl-medium",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-text-color-mid-em text-body-lg",
                            children: "Only Features:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: features.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-start space-x-2 my-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: checkGreySrc,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[#667085] text-body-lg",
                                            children: item
                                        })
                                    ]
                                }, item);
                            })
                        })
                    ]
                })
            ]
        });
    };
    var MobileTable = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-16 px-5 sm-2:!px-10 space-y-6 pb-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientList, {
                    features: SimpleWasteAccountFeatures
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GreyList, {
                    title: "Traditional Broker",
                    features: TraditionalBrokerFeatures
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GreyList, {
                    title: "Typical Hauler Account",
                    features: TypicalHaulerAccountFeatures
                })
            ]
        });
    };
    var TableRow = function(data) {
        var _data = data.data, feature = _data.feature, SWA = _data.SWA, TB = _data.TB, THA = _data.THA, columnBg = _data.columnBg, isLast = _data.isLast;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row px-6 items-center bg-[".concat(columnBg, "]"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "basis-1/4 mr-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[#101828] label-md lg:label-lg xl:label-xl",
                        children: feature
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "basis-1/4 h-20 flex flex-col justify-center items-center \n        border-x-2 border-secondary-light px-5\n        ".concat(isLast ? "border-b-2 border-b-secondary-light rounded-b-2xl" : ""),
                    children: SWA ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: checkSrc,
                        alt: ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: crossSrc,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "basis-1/4 flex flex-col justify-center items-center px-5",
                    children: !TB ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: crossSrc,
                        alt: ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-body-md lg:label-lg xl:label-xl text-[#667085]",
                        children: "Limited"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "basis-1/4 flex flex-col justify-center items-center px-5",
                    children: !THA ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: crossSrc,
                        alt: ""
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-body-md lg:label-lg xl:label-xl text-[#667085]",
                        children: "Limited"
                    })
                })
            ]
        });
    };
    var DesktopTable = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-16 px-6 lg:px-16 xl:px-28 pb-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row px-6 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "basis-1/4 mr-10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                            overrideClassName: "basis-1/4 h-20 flex flex-col justify-center items-center text-center rounded-t-2xl px-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white label-md lg:label-lg xl:label-xl",
                                children: "SimpleWaste Account"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "basis-1/4 flex flex-col justify-center items-center text-center px-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-text-color-high-em label-md lg:label-lg xl:label-xl",
                                children: "Traditional Broker"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "basis-1/4 flex flex-col justify-center items-center text-center px-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-text-color-high-em label-md lg:label-lg xl:label-xl",
                                children: "Typical Hauler Account"
                            })
                        })
                    ]
                }),
                TableData.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow, {
                        data: item
                    }, item.feature);
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "pt-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-3 xs:px-4 md:px-8 lg:px-0 text-center md:text-start md:ml-6 lg:ml-16 xl:ml-32 lg:pr-4 2xl:pr-14 3xl:pr-[200px] 4xl:pr-[440px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "label-lg text-secondary",
                        children: "PLATFORM ADVANTAGES"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "h4 sm:h3 md:h2 text-background-primary-dark",
                        children: "SimpleWaste is better than the competition."
                    })
                ]
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTable, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopTable, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-[1440px] mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partners_landing_sections_prompt, {
                            offerLabel: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-background-low-em-dark absolute bottom-0 h-1/2 w-full"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var table = (Table);

;// CONCATENATED MODULE: ./pages/platform.tsx

/* eslint-disable @next/next/no-img-element */ 





var PlatformPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(technology, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(procurement, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(support, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(setup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(table, {})
        ]
    });
};
/* harmony default export */ var platform = (PlatformPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4672); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);